/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { GetterTree, MutationTree, ActionTree } from "vuex";
import {
  PersonalInfo,
  LoginInfo,
  Address,
  ESign,
  AddressMutationPayload,
  TokenData
} from "@/types/customerInfo";
import axios from "axios";
interface State {
  personalInfo: PersonalInfo;
  loginInfo: LoginInfo;
  address: Address;
  shippingAddress: Address;
  eSign: ESign;
  tokenData: TokenData;
  additionalJsonData: any;
  responseData: any;
}

export const state: State = {
  personalInfo: {
    firstName: "",
    lastName: "",
    dob: "",
    ssn: "",
    mobilePhone: ""
  },
  loginInfo: {
    email: "",
    password: ""
  },
  address: {
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: ""
  },
  shippingAddress: {
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: ""
  },
  eSign: {
    agreed: false,
    date: null,
    version: ""
  },
  tokenData: {
    fiId: "52124",
    accountType: "DDA",
    productType: "KASASA_CASH_EDGE",
    externalProductMappingId: ""
  },
  additionalJsonData: {
    middleName: "NMN",
    occupation: "placeholder data",
    employer: "placeholder data",
    driverLicenseNumber: "placeholder data",
    driverLicenseIssuingState: "placeholder data",
    driverLicenseIssueDate: "placeholder data",
    driverLicenseExpirationDate: "placeholder data"
  },
  responseData: {}
};

export const getters: GetterTree<State, any> = {
  firstName: (state: State): string => state.personalInfo.firstName,
  lastName: (state: State): string => state.personalInfo.lastName,
  dob: (state: State): string => state.personalInfo.dob,
  ssn: (state: State): string => state.personalInfo.ssn,
  mobilePhone: (state: State): string => state.personalInfo.mobilePhone,
  email: (state: State): string => state.loginInfo.email,
  password: (state: State): string => state.loginInfo.password,
  address: (state: State): Address => state.address,
  shippingAddress: (state: State): Address => state.shippingAddress,
  eSign: (state: State): boolean => state.eSign.agreed,
  tokenData: (state: State): TokenData => state.tokenData,
  additionalJsonData: (state: State): any => JSON.stringify(state.additionalJsonData, null, 2),
  responseData: (state: State): any => state.responseData
};

export const mutations: MutationTree<State> = {
  SET_FIRSTNAME(state, value) {
    state.personalInfo.firstName = value;
  },
  SET_LASTNAME(state, value) {
    state.personalInfo.lastName = value;
  },
  SET_DOB(state, value) {
    state.personalInfo.dob = value;
  },
  SET_SSN(state, value) {
    state.personalInfo.ssn = value;
  },
  SET_MOBILE_PHONE(state, value) {
    state.personalInfo.mobilePhone = value;
  },
  SET_EMAIL(state, value) {
    state.loginInfo.email = value;
  },
  SET_PASSWORD(state, value) {
    state.loginInfo.password = value;
  },
  SET_ADDRESS_FIELD(state, { fieldName, value }: AddressMutationPayload) {
    state.address = { ...state.address, [fieldName]: value };
  },
  SET_SHIPPING_ADDRESS_FIELD(state, { fieldName, value }: AddressMutationPayload) {
    state.shippingAddress = { ...state.shippingAddress, [fieldName]: value };
  },
  SET_E_SIGN(
    state,
    payload: {
      value: boolean;
      version: string;
    }
  ) {
    const { value, version } = payload;
    state.eSign = { agreed: value, date: new Date(), version };
  },
  SET_TOKEN_DATA(state, payload: TokenData) {
    state.tokenData = { ...state.tokenData, ...payload };
  },
  SET_ADDITIONAL_JSON(state, payload: any) {
    state.additionalJsonData = JSON.parse(payload);
  }
};

export const actions: ActionTree<State, any> = {
  async submitPersonalInfoAndLoginInfo({ state }, timeout) {
    console.log(state);

    // TODO: call api with state.personalInfo and state.loginInfo
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, timeout);
    });
  },
  async submitRequestPlaceholder({ state }, timeout) {
    // TODO: format masked fields
    // TODO: call api
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, timeout);
    });
  },
  async submitAccountOpeningRequest({ state }) {
    const requestBody = {
      fiId: parseInt(state.tokenData.fiId as string),
      accountType: state.tokenData.accountType,
      productName: state.tokenData.productType,
      externalProductMappingId: state.tokenData.externalProductMappingId,
      firstName: state.personalInfo.firstName,
      lastName: state.personalInfo.lastName,
      ssn: state.personalInfo.ssn.replace(/\D+/g, ""),
      mobilePhone: state.personalInfo.mobilePhone.replace(/\D+/g, ""),
      dateOfBirth: state.personalInfo.dob.replace(/(\d{2})\/(\d{2})\/(\d{4})/g, "$3-$1-$2"),
      email: state.loginInfo.email,
      address1: state.address.address1,
      address2: state.address.address2,
      city: state.address.city,
      state: state.address.state,
      postalCode: state.address.zip,
      ...state.additionalJsonData
    };
    try {
      const response = await axios.post("http://localhost:8080/kmny-account/accounts", requestBody);
      if (response.data) {
        state.responseData = response.data;
      } else {
        state.responseData = response;
      }
    } catch (error) {
      state.responseData = error;
    }
    return;
  }
};
